import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import AirlinesFilter from './airlinesFilter'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'

const AirlineFilterNew = ({
  onFilterChange,
  airlineFilter,
  showPerAdultPricing,
  isRT,
  returnAirlineFilter,
  processedData,
  clearFiltersCategoryWise,
  selectedFilters,
  hideMultiAirlineBlock = false,
  isRevamp = false,
}: {
  onFilterChange: (type: any, value: any, index?: number, legKey?: 'onwardLeg' | 'returnLeg') => void
  airlineFilter: any
  showPerAdultPricing: boolean
  isRT: boolean
  returnAirlineFilter: any
  processedData: any
  clearFiltersCategoryWise: any
  selectedFilters: any
  hideMultiAirlineBlock?: boolean
  isRevamp?: boolean
}) => {
  const onClear = () => clearFiltersCategoryWise(selectedFilters, isRT, 'airlineFilter')
  const showBothLegs = isRT && !isEmpty(returnAirlineFilter?.options)
  const count = (airlineFilter?.selectedValues?.length || 0) + (returnAirlineFilter?.selectedValues?.length || 0)
  const shared = { hideMultiAirlineBlock, isRevamp, isRT, showPerAdultPricing }

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Airlines' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(airlineFilter?.options) && (
          <AirlinesFilter
            {...shared}
            airlineFilter={airlineFilter}
            from={processedData?.source}
            to={processedData?.destination}
            onFilterChange={onFilterChange as React.ComponentProps<typeof AirlinesFilter>['onFilterChange']}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showBothLegs} />

        {showBothLegs && (
          <AirlinesFilter
            {...shared}
            airlineFilter={returnAirlineFilter}
            from={processedData?.destination}
            to={processedData?.source}
            onFilterChange={
              ((type: any, value: any) => onFilterChange(type, value, 0, 'returnLeg')) as React.ComponentProps<
                typeof AirlinesFilter
              >['onFilterChange']
            }
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default AirlineFilterNew
